export const LOGO_IMPORT = 'LOGO_IMPORT'
export const LOGO_IMPORT_SERVER_RESOURCE = '/settings-upload'

export const ADD_HEADER_LINK_URL = 'ADD_HEADER_LINK_URL'
export const UPDATE_HEADER_LINK_URL = 'UPDATE_HEADER_LINK_URL'

export const HEADER_IMAGE_URL = 'brand_header_image_url'
export const HEADER_URL = 'brand_header_url'

export const ALL_KEYS = [ HEADER_IMAGE_URL, HEADER_URL ]

export const LOGO_UPLOAD_HELP_TEXT =
  `Please select an image file for the header logo of the newsbrief.`



// WEBPACK FOOTER //
// ./src/pages/newsbrief/logo/constants.ts